import classNames from 'classnames';
import Skeleton from '@/components/Skeleton';
import styles from './NeedsAttention.module.scss';

const SkeletonRow = () => (
  <li>
    <div className={classNames(styles.row, styles.rowSkeleton)}>
      <Skeleton className={styles.iconSkeleton} />
      <div className={styles.meta}>
        <Skeleton className={styles.titleSkeleton} />
        <Skeleton className={styles.subtitleSkeleton} />
      </div>
    </div>
  </li>
);

export default SkeletonRow;
